import * as Lookup from "./lookup";
export const STRIJKREGELS = [
    [0, 0, 0, 0, 0, 1, 0, "420117", "049530", 2, "10-255", "102551", "Strijkregel 33C1 R320Cr,recht,5.000mm"],
    [1, 0, 0, 0, 0, 0, 0, "420116", "049530", 2, "10-255", "102551", "Strijkregel 33C1 R320Cr,recht,5.000mm"],
    [2, 0, 1, 0, 0, 1, 1, "413821", "048452", 2, "10-211", "102111", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
    [3, 0, 1, 0, 0, 0, 1, "420006", "48452", 2, "10-211", "102111", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
    [4, 0, 0, 0, 0, 1, 0, "420117", "049530", 2, "10-255", "102551", "Strijkregel 33C1 R320Cr,recht,5.000mm"],
    [5, 1, 0, 0, 0, 2, 2, "415098", "49530", 2, "10-255", "102551", "Strijkregel 33C1 R320Cr,recht,5.000mm"],
    [6, 4, 2, 0, 0, -1, -1, "420306", "42574", 4, "10-261", "102611", "Strijkregel 33C1 R320Cr,recht,4.000mm"],
    [7, 2, 0, 0, 0, -1, 3, "415099", "415409", 4, "10-278", "102781", "Strijkregel 33C1 R320Cr,recht,4.580mm"],
    [8, 3, 0, 0, 0, -1, 3, "415100", "415409", 4, "10-278", "102781", "Strijkregel 33C1 R320Cr,recht,4.580mm"],
    [9, 2, 0, 1, 0, -1, 3, "412622", "049530", 4, "10-255", "102551", "Strijkregel 33C1 R320Cr,recht,5.000mm"],
    [10, 0, 0, 1, 0, 0, 0, "411508", "049530", 2, "10-255", "102551", "Strijkregel 33C1 R320Cr,recht,5.000mm"],
    [11, 0, 0, 1, 0, 1, 0, "411508", "049530", 2, "10-255", "102551", "Strijkregel 33C1 R320Cr,recht,5.000mm"],
    [12, 1, 1, 0, 0, -1, 7, "415256", "49284", 2, "10-214", "102141", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
    [13, 0, 0, 0, 0, 0, 4, "415014", "48452", 1, "10-211", "102111", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
    [14, 0, 0, 0, 0, 0, 4, "415014", "49649", 1, "10-232", "102321", "Strijkregel 33C1 R320Cr,gebogen,6.000mm"],
    [15, 0, 1, -1, 0, 1, 1, "48454", "48452", 2, "10-211", "102111", "Strijkregel 33C1 R320Cr lang 6.000 mm recht"],
    [16, 0, 3, 0, 0, 0, 6, "420051", "41377", 1, "10-220", "102201", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
    [17, 0, 3, 0, 0, 0, 6, "420051", "41377", 1, "10-230", "102301", "Strijkregel 33C1 R320Cr,gebogen,6.000mm"],
    [18, 0, 3, 0, 0, 1, 6, "420052", "41377", 1, "10-220", "102201", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
    [19, 0, 3, 0, 0, 1, 6, "420052", "41377", 1, "10-230", "102301", "Strijkregel 33C1 R320Cr,gebogen,6.000mm"],
    [20, 2, 0, 0, 0, -1, 3, "415099", "415409", 4, "10-278", "183621", "Lasrugplaat,vk,anor,54E1 Links"],
    [21, 2, 3, 0, 0, -1, 5, "435113", "435114", 4, "10-284", "102841", "Strijkregel 33C1 R320Cr,recht,5.560mm"],
    [22, 0, 3, 1, 0, 0, 6, "413574", "41377", 1, "10-220", "102201", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
    [23, 0, 3, 1, 0, 0, 6, "413574", "41377", 1, "10-230", "102301", "Strijkregel 33C1 R320Cr,gebogen,6.000mm"],
    [24, 0, 3, 1, 0, 1, 6, "413574", "41377", 1, "10-220", "102201", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
    [25, 0, 3, 1, 0, 1, 6, "413574", "41377", 1, "10-230", "102301", "Strijkregel 33C1 R320Cr,gebogen,6.000mm"],
    [26, 0, 3, 0, 0, 0, 6, "416093", "416122", 1, "10-710", "107101", "Strijkregel 33C1 R320Cr recht lang 5.560 mm"],
    [27, 0, 3, 0, 0, 0, 6, "416093", "416122", 1, "10-711", "107111", "Strijkregel 33C1 R320Cr gebogen lang 5.560 mm"],
    [28, 0, 3, 0, 0, 1, 6, "416094", "416122", 1, "10-710", "107101", "Strijkregel 33C1 R320Cr recht lang 5.560 mm"],
    [29, 0, 3, 0, 0, 1, 6, "416094", "416122", 1, "10-711", "107111", "Strijkregel 33C1 R320Cr gebogen lang 5.560 mm"],
    [30, 0, 3, 0, 0, 0, 6, "416095", "416122", 1, "10-710", "107101", "Strijkregel 33C1 R320Cr recht lang 5.560 mm"],
    [31, 0, 3, 0, 0, 0, 6, "416095", "416122", 1, "10-711", "107111", "Strijkregel 33C1 R320Cr gebogen lang 5.560 mm"],
    [32, 0, 1, 0, 0, 0, 8, "414466", "49289", 2, "10-214", "102141", "Strijkregel 33C1 R320Cr,recht,6.000mm"],
];
export const parse = (row) => {
    const [_key, _wissel, _hoek, _ligger, _profiel, _richting, _boogstraal, teknrWissel, teknrComp, aantal, bovenbouwCode, artCodeTSNL, omschrijving] = row;
    const parsed = {
        key: _key,
        wissel: Lookup.wissel[_wissel],
        hoek: Lookup.hoek[_hoek],
        ligger: _ligger === -1 ? undefined : Lookup.wisselLigger[_ligger],
        profiel: Lookup.profiel[_profiel],
        richting: _richting === -1 ? undefined : Lookup.richting[_richting],
        boogstraal: _boogstraal === -1 ? undefined : Lookup.boogstraal[_boogstraal],
        teknrWissel,
        teknrComp,
        aantal,
        bovenbouwCode,
        artCodeTSNL,
        category: "strijkregels",
        _omschrijving: omschrijving,
        description() { return description(parsed); },
    };
    return parsed;
};
export const description = (row) => {
    // ${getTextFixed("strijkregel")}
    return `${row._omschrijving} (${row.artCodeTSNL})`;
};
